import { getTheme, Icon } from "@fluentui/react";

const theme = getTheme();

interface ClearIconProps {
  handleClearSelection: () => void;
  title: string;
  ariaLabel: string;
  disabled?: boolean;
}

export const ClearIcon = ({
  handleClearSelection,
  title,
  ariaLabel,
  disabled
}: ClearIconProps) => {
  if (disabled) {
    return null;
  }

  return (
    <Icon
      iconName="Delete"
      onClick={handleClearSelection}
      styles={{
        root: {
          cursor: "pointer",
          fontSize: "16px",
          color: theme.palette.neutralSecondary,
          selectors: {
            ":hover": {
              color: theme.palette.red
            }
          }
        }
      }}
      title={title}
      aria-label={ariaLabel}
    />
  );
};
